module.exports = __webpack_public_path__ + "static/img/06.2ba410a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/about/06.jpg
// module id = 26
// module chunks = 0